import Image from "next/image";
import {
  addBasePathToStrapiMedia,
  formatStrapiEntity,
  StrapiEntity,
  StrapiImage,
} from "@/utils/strapi";
import styles from "./Accessory.module.scss";

export type AccessoryProps = {
  label: string;
  picto: StrapiEntity<StrapiImage>;
};

export const Accessory = ({ label, picto }: AccessoryProps) => {
  const strapiImage = formatStrapiEntity(picto);

  return (
    <div className={styles.cardLayout}>
      <Image
        src={addBasePathToStrapiMedia(strapiImage)}
        width={64}
        height={64}
        layout="fixed"
        alt={strapiImage.alternativeText ?? ""}
      />

      <div className={styles.label}>{label}</div>
    </div>
  );
};
